export default __webpack_public_path__ + "static/media/notAvailable-removebg-preview.383db640.svg";